import React from 'react'
import { Route } from 'react-router-dom'
import { paths } from '../../paths'

export const budgetresultsarticlepricelist: JSX.Element[] = [
  <Route
    component={React.lazy(async () => {
      const { BudgetResultsArticlePriceListPage } = await import(
        /* webpackChunkName: "BudgetResultsArticlePriceListPage" */
        '../../../components/pages/private/BudgetResultsArticlePriceListPage'
      )
      return {
        default: BudgetResultsArticlePriceListPage,
      }
    })}
    exact
    key={paths.budgetResultItemPriceList}
    path={paths.budgetResultItemPriceList}
  />,
]
